var EntitiesBase = require('./base_rest');
var lsCache = require('lscache');
var Moment = require('moment');
var validationUtils = require('./validation');
var DateUtils = require('../utils/dates');

var LAT_MIN = -90;
var LAT_MAX = 90;
var LONG_MIN = -180;
var LONG_MAX = 180;

var LOCATION_TYPES = {
    STORE: 'store', // Physical store
    ONLINE: 'online', // Mail order
};

var LocationModel = EntitiesBase.ModelBase.extend({
    validation: {
        name: {
            required: true
        },
        slug: {
            required: true
        },
        type: {
            required: true
        },
        phone: {
            required: true
        },
        email: {
            required: true,
            pattern: 'email'
        },
        line_1: {
            required: true
        },
        city: {
            required: true
        },
        postal_code: {
            required: true,
            msg: validationUtils.getIsRequiredMessageForFieldName('Postal Code')
        },
        province: {
            required: true
        },
        lat: {
            required: function() {
                return this.get('type') === LOCATION_TYPES.STORE;
            },
            latitude: true,
        },
        lng: {
            required: function() {
                return this.get('type') === LOCATION_TYPES.STORE;
            },
            longitude: true,
        },
        map_url: {
            required: function() {
                return this.get('type') === LOCATION_TYPES.STORE;
            }
        },
        delivery_hours_monday_start_time: function(value) {
            if (this.validateDeliveryStartEndTime(value, 'monday')) {
                return 'Error';
            }
        },
        delivery_hours_monday_end_time: function(value) {
            if (this.validateDeliveryStartEndTime(value, 'monday')) {
                return 'Error';
            }
        },
        delivery_hours_tuesday_start_time: function(value) {
            if (this.validateDeliveryStartEndTime(value, 'tuesday')) {
                return 'Error';
            }
        },
        delivery_hours_tuesday_end_time: function(value) {
            if (this.validateDeliveryStartEndTime(value, 'tuesday')) {
                return 'Error';
            }
        },
        delivery_hours_wednesday_start_time: function(value) {
            if (this.validateDeliveryStartEndTime(value, 'wednesday')) {
                return 'Error';
            }
        },
        delivery_hours_wednesday_end_time: function(value) {
            if (this.validateDeliveryStartEndTime(value, 'wednesday')) {
                return 'Error';
            }
        },
        delivery_hours_thursday_start_time: function(value) {
            if (this.validateDeliveryStartEndTime(value, 'thursday')) {
                return 'Error';
            }
        },
        delivery_hours_thursday_end_time: function(value) {
            if (this.validateDeliveryStartEndTime(value, 'thursday')) {
                return 'Error';
            }
        },
        delivery_hours_friday_start_time: function(value) {
            if (this.validateDeliveryStartEndTime(value, 'friday')) {
                return 'Error';
            }
        },
        delivery_hours_friday_end_time: function(value) {
            if (this.validateDeliveryStartEndTime(value, 'friday')) {
                return 'Error';
            }
        },
        delivery_hours_saturday_start_time: function(value) {
            if (this.validateDeliveryStartEndTime(value, 'saturday')) {
                return 'Error';
            }
        },
        delivery_hours_saturday_end_time: function(value) {
            if (this.validateDeliveryStartEndTime(value, 'saturday')) {
                return 'Error';
            }
        },
        delivery_hours_sunday_start_time: function(value) {
            if (this.validateDeliveryStartEndTime(value, 'sunday')) {
                return 'Error';
            }
        },
        delivery_hours_sunday_end_time: function(value) {
            if (this.validateDeliveryStartEndTime(value, 'sunday')) {
                return 'Error';
            }
        },
        default_tip: {
            required: true
        }
    },
    validateDeliveryStartEndTime: function (value, index) {
        var open = parseInt(this.get('delivery_hours_' + index + '_open')) == 1 || 
        this.get('delivery_hours_' + index + '_open') == true;
        if ((!value || value == '') && open) {
            return true;
        }
    },
    LOCATION_TYPES: LOCATION_TYPES,
    urlRoot: function () {
        return farmacy.settings.restAPI.root + 'wp/v3/locations';
    },
    defaults: {
        'type': LOCATION_TYPES.STORE
    },
    deliveryNextAvailable: function () {

        var serverUnixTime = moment().unix() + this.get('server_client_time_offset');
        var days_of_the_week = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
        
        var today_lower = DateUtils.getFormattedTimestamp(serverUnixTime, {
                format: 'dddd'
        }).toLowerCase();
        var open = 0;
        var loop_count = 0;

        var today_open = this.get('delivery_hours_' + today_lower + '_open');
        var today_start_time = this.get('delivery_hours_' + today_lower + '_start_time');
        var today_end_time = this.get('delivery_hours_' + today_lower + '_end_time');
        var dayOffset = 0;
        //determine its before opening, or after closing on the current day
        //-1 is before, 0 is after
 
        if (today_open == '1' && 
            today_start_time !== null && 
            today_start_time !== '' && 
            today_end_time !== null && 
            today_end_time !== '') {
            var dateString = DateUtils.getFormattedTimestamp(serverUnixTime, {
                format: 'YYYY-MM-DD'
            });
            var startTimeUnixTime = moment(dateString + ' ' + today_start_time, 'YYYY-MM-DD H:mmA').unix() + this.get('server_client_time_offset');
            var endTimeUnixTime = moment(dateString + ' ' + today_end_time, 'YYYY-MM-DD H:mmA').unix() + this.get('server_client_time_offset');
            if (serverUnixTime <= startTimeUnixTime || serverUnixTime <= endTimeUnixTime) {
                dayOffset = 1;
            }
        }
        var day_array_key = days_of_the_week.indexOf(today_lower) - dayOffset;

        while(open == 0) {
            if (day_array_key == ( days_of_the_week.length - 1) ) {
                day_array_key = 0;
            } else {
                day_array_key += 1;
            }

            var day_lower = days_of_the_week[day_array_key];
            var open_day = this.get('delivery_hours_' + day_lower + '_open');
            var day_start_time = this.get('delivery_hours_' + day_lower + '_start_time');
            var day_end_time = this.get('delivery_hours_' + day_lower + '_end_time');
            if (open_day == '1' && 
                day_start_time !== null && 
                day_start_time !== '' && 
                day_end_time !== null && 
                day_end_time !== '') {
                open = true;
            }

            loop_count += 1;
            if (loop_count >= 6) {
                break;
            }
        }
        if (open == 0) {
            return {
                day: null,
                available: false,
                startTime: null,
                endTime: null
            }
        } else {
            var isToday = false;
            if (today_lower == day_lower) {
                isToday = true;
            }
            return {
                isToday: isToday,
                day: day_lower,
                available: open,
                startTime: day_start_time,
                endTime: day_end_time
            }
        }
    },
    isDeliveryAvailableAtCurrentTime: function () {
        var deliveryAvailable = false;
        var serverUnixTimePST = moment().tz("America/Los_Angeles").unix() + this.get('server_client_time_offset');

        var dayOfTheWeek = moment.tz(serverUnixTimePST * 1000, "America/Los_Angeles").format('dddd').toLowerCase();
        var dateString = moment.tz(serverUnixTimePST * 1000, "America/Los_Angeles").format('YYYY-MM-DD');

        var isDeliveryOpen = this.get('delivery_hours_' + dayOfTheWeek + '_open');
        var startTime = this.get('delivery_hours_' + dayOfTheWeek + '_start_time');
        var endTime = this.get('delivery_hours_' + dayOfTheWeek + '_end_time');

        if (isDeliveryOpen == '1' && startTime && endTime) {
            var startTimeUnixTime = moment.tz(dateString + ' ' + startTime, 'YYYY-MM-DD H:mmA', "America/Los_Angeles").unix();
            var endTimeUnixTime = moment.tz(dateString + ' ' + endTime, 'YYYY-MM-DD H:mmA', "America/Los_Angeles").unix();
                        
            if (serverUnixTimePST >= startTimeUnixTime && serverUnixTimePST < endTimeUnixTime) {
                deliveryAvailable = true;
            }
        }

        var result = {
            available: deliveryAvailable,
            startTime: startTime,
            endTime: endTime
        };

        return result;
    },
    parse: function (response) {

        response.server_client_time_offset = response.server_time - moment().unix();
        
        response.is_active = response.is_active === "1" ? true : false;
        response.temp_closed = response.temp_closed === "1" ? true : false;
        response.delivery_active = response.delivery_active === "1" ? true : false;
        response.payments_allow_online = response.payments_allow_online === "1" ? true : false
        response.default_tip = parseFloat(response.default_tip);
        return EntitiesBase.ModelBase.prototype.parse.call(this, response);
    }
});
_.extend(LocationModel.prototype, Backbone.Validation.mixin);

var PageableLocationCollection = EntitiesBase.PageableCollectionBase.extend({
    url: function () {
        return farmacy.settings.restAPI.root + 'wp/v3/locations';
    },
    initialize: function (models) {
        _.each(models, function (model) {
            model.server_client_time_offset = model.server_time - moment().unix();
        });
    },
    model: LocationModel,
    state: _.extend({}, EntitiesBase.PageableCollectionBase.prototype.state, {
        sortKey: 'name'
    })
});

var ProductLocationsCollection = PageableLocationCollection.extend({
    productId: null,
    initialize: function (models, options) {
        this.productId = options.productId;
    },
    fetchParams: function () {
        return _.extend(
            {},
            EntitiesBase.CollectionBase.prototype.fetchParams.call(this),
            {
                product_id: this.productId
            }
        );
    }
});

function getLocationTypes() {
    var col = new EntitiesBase.CollectionBase([
        {
            label: 'Store',
            id: LOCATION_TYPES.STORE
        },
        {
            label: 'Online',
            id: LOCATION_TYPES.ONLINE
        }
    ]);

    return col;
}

function getUserSavedLocation() {
  return lsCache.get('farmUserSavedLocation');
}

function saveUserLocation(slug) {
  // expire in a year....
  lsCache.set('farmUserSavedLocation',slug, 31556952000);
  return true;
}

module.exports = {
    LOCATION_TYPES: LOCATION_TYPES,
    getLocationTypes: getLocationTypes,
    LocationModel: LocationModel,
    getUserSavedLocation: getUserSavedLocation,
    saveUserLocation: saveUserLocation,
    PageableLocationCollection: PageableLocationCollection,
    ProductLocationsCollection: ProductLocationsCollection
};



/** WEBPACK FOOTER **
 ** ./assets/js/entities/location.js
 **/